import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import Immutable from 'immutable';
import PropTypes from 'prop-types';

var SearchParamsUpdate = /*#__PURE__*/function (_Immutable$Record) {
  _inherits(SearchParamsUpdate, _Immutable$Record);

  var _super = _createSuper(SearchParamsUpdate);

  function SearchParamsUpdate() {
    _classCallCheck(this, SearchParamsUpdate);

    return _super.apply(this, arguments);
  }

  _createClass(SearchParamsUpdate, [{
    key: "compose",
    value: function compose(spu2) {
      var _this = this;

      return new SearchParamsUpdate({
        types: this.types.concat(spu2.types),
        apply: function apply(params) {
          return spu2.apply(_this.apply(params));
        }
      });
    }
  }, {
    key: "copy",
    value: function copy(_ref) {
      var types = _ref.types,
          apply = _ref.apply;
      return new SearchParamsUpdate({
        types: types || this.types,
        apply: apply || this.apply
      });
    }
    /**
     * @param f : params => params
     * @return {SearchParamsUpdate}
     */

  }, {
    key: "composeApply",
    value: function composeApply(f) {
      var _this2 = this;

      return new SearchParamsUpdate({
        types: this.types,
        apply: function apply(params) {
          return f(_this2.apply(params));
        }
      });
    }
  }], [{
    key: "default_",
    value: function default_() {
      return new SearchParamsUpdate({
        types: Immutable.Set(),
        apply: function apply(q) {
          return q;
        }
      });
    }
  }]);

  return SearchParamsUpdate;
}(Immutable.Record({
  /**
   * Set[FacetType]
   */
  types: undefined,

  /**
   * params => params
   */
  apply: undefined
}));

export { SearchParamsUpdate as default };
export var SearchParamsUpdatePropType = PropTypes.instanceOf(SearchParamsUpdate);